
























































































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../../requester';

import { ConviteUsuarioNovoFormData } from '../../../../back/src/types';
import { ConviteUsuario } from '../../../../back/src/entity/ConviteUsuario';

import Confirmar from '../../components/Confirmar.vue';
import TheConvitesUsuariosModalNovoConvite from '../../components/convites_usuarios/TheConvitesUsuariosModalNovoConvite.vue';

export default Vue.extend({
  name: 'ConvitesUsuariosIndex',
  components: {
    Confirmar,
    TheConvitesUsuariosModalNovoConvite,
  },
  data() {
    return {
      loading: {
        table: true,
        submit: false,
      },
      confirmacao: {
        reenviaConvite: false,
        deletaConvite: false,
      },
      convites: [] as ConviteUsuario[],
      conviteSelecionado: {} as ConviteUsuario,
      search: '',
    };
  },
  computed: {
    confirmar(): Vue & { open: (titulo: string, mensagem: string) => Promise<boolean> } {
      return this.$refs.confirmar as Vue & {
        open: (titulo: string, mensagem: string) => Promise<boolean>
      };
    },
    headers() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return [
          {
            value: 'email',
            text: 'Email ',
            sortable: true,
          },
          {
            value: 'actions',
            text: 'Ações',
            sortable: false,
            width: 0,
            align: 'center',
          },
        ];
      }
      return [
        {
          value: 'email',
          text: 'Email ',
          sortable: true,
        },
        {
          value: 'updated',
          text: 'Enviado em ',
          sortable: true,
          align: 'center',
        },
        {
          value: 'actions',
          text: 'Ações',
          sortable: false,
          width: 0,
          align: 'center',
        },
      ];
    },
    listaConvites(): ConviteUsuario[] {
      return _.filter(this.convites, (convite: ConviteUsuario) => !convite.usuario_id);
    },
  },
  mounted() {
    this.getConvitesUsuarios();
  },
  methods: {
    clickRow(conviteUsuario: ConviteUsuario) {
      this.conviteSelecionado = conviteUsuario;
    },
    updateConvites(convite: ConviteUsuario) {
      const index = _.findIndex(this.convites, (el: ConviteUsuario) => el.id === convite.id);
      if (index >= 0) {
        this.$set(this.convites, index, convite);
        this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Convite reenviado com sucesso!' });
      } else {
        this.convites.push(convite);
        this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Convite enviado com sucesso!' });
      }
    },
    async reenviaConvite(email: string): Promise<void> {
      if (await this.confirmar.open(
        'Reenviar convite',
        'Tem certeza que deseja reenviar este convite?',
      ) === false) {
        return;
      }
      this.loading.submit = true;
      const formData: ConviteUsuarioNovoFormData = { email };
      try {
        const response = await Requester.conviteUsuario.criaConviteUsuario(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.updateConvites(response.data);
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.submit = false;
      }
    },
    async deletaConvite(conviteUsuarioId: number): Promise<void> {
      if (await this.confirmar.open(
        'Remover convite',
        'Tem certeza que deseja remover este convite?',
      ) === false) {
        return;
      }
      this.loading.submit = true;
      try {
        const response = await Requester.conviteUsuario.deletaConviteUsuario(conviteUsuarioId);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          const index = _.findIndex(
            this.convites as ConviteUsuario[],
            el => el.id === conviteUsuarioId,
          );
          this.$delete(this.convites, index);
          this.$root.$emit('avisoSnackbar', {
            color: 'success',
            text: 'Convite removido com sucesso!',
          });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.submit = false;
      }
    },
    async getConvitesUsuarios(): Promise<void> {
      this.loading.table = true;
      try {
        const response = await Requester.conviteUsuario.convitesUsuarios();
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.convites = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.table = false;
      }
    },
  },
});
